var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconXp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.21875,
    y: 14,
    width: 18.7487,
    height: 18.7487,
    rx: 4,
    transform: "rotate(-45 0.21875 14)",
    fill: "#17181C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.536 17.125H12.0586L10.7789 15.0893L9.49918 17.125H8.03125L10.0449 13.9196L8.13476 10.875H9.60269L10.7789 12.75L11.9551 10.875H13.4231L11.5129 13.9107L13.536 17.125Z",
    fill: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7198 10.875C17.9901 10.875 18.9687 11.8036 18.9687 12.9732C18.9687 14.1429 17.9901 15.0714 16.7198 15.0714H15.5624V17.125H14.2638V10.875H16.7198ZM16.7198 13.9196C17.275 13.9196 17.6796 13.5089 17.6796 12.9732C17.6796 12.4286 17.275 12.0268 16.7198 12.0268H15.5624V13.9196H16.7198Z",
    fill: "#E7E7E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXp);
export default __webpack_public_path__ + "static/media/icon_xp.c2d5a1581e2687b96b83d10268e832a9.svg";
export { ForwardRef as ReactComponent };